
import api from "../utils/axios";
export async function getMedicineTypes() {

    console.log('getMedicineTypes');
  try {
    const res = await api.get(`/medicine-types`);
    return res.data.data;
  } catch (error) {
    console.error("Failed to load Orders:", error);
    throw error;
  }
}



export async function getMedicineUnits(typeId) {
  const response = await api.get(`/medicine-types/${typeId}/units`);
  return response.data.data;
}

